module.exports = __webpack_public_path__ + "img/729.42f56509.jpg";